/// <amd-module name="Wit/UI/ComponentProviders/BaseProvider/index" />
export { ChildrenCallBack, IBaseProviderProps } from "./BaseProviderComponent.Props";
export * from "./BaseProviderComponent";
